import React, { useState, useEffect } from "react";
import { Div, Text } from "../../Kit";

export const ProgressBarLoading = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + Math.random() * 3;
        return next >= 90 ? 90 : next;
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center" dir="ltr">
      <Div className="bg-[#DFDFDF] w-[140px] h-[7px] rounded-[5px]">
        <Div
          bg="primary"
          className="h-full rounded-[5px]"
          style={{
            width: `${progress}%`,
            transition: "width 0.3s ease",
          }}
        />
      </Div>
      <Text elementType="span" className="text-sm mt-[8px]" translatable={false}>
        {Math.floor(progress)}%
      </Text>
    </div>
  );
};
